import React, { memo } from 'react';
import PropTypes from 'prop-types'; // Import PropTypes
import styled from 'styled-components';

const PlusIcon = ({ width = 30, height = 30 }) => (
  <PlusSvg width={width} height={height} viewBox="0 0 10 10">
    <path d="M6 0H4V4H0V6H4V10H6V6H10V4H6V0Z" />
  </PlusSvg>
);

PlusIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

const PlusSvg = styled.svg`
  fill: ${(props) => props.theme.main.iconDefault};
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
`;

export default memo(PlusIcon);
